export type DocumentMessages = {
  rgOption: string;
  cpfOption: string;
  cnpjOption: string;
  individualOption: string;
  corporateOption: string;
};

export const DOCUMENT_MESSAGES: DocumentMessages = {
  rgOption: "Registro Geral",
  cpfOption: "CPF",
  cnpjOption: "CNPJ",
  individualOption: "Pessoa Física",
  corporateOption: "Pessoa Jurídica",
};
